import unit from "../unit";

/**
 * Returns border radius (defined in theme object)
 *
 * @param theme - Theme object
 * @param radius - Radius size
 * @returns Radius value from theme in rem units
 */
var getBorderRadius = function getBorderRadius(theme, radius) {
  return typeof theme.borderRadius[radius] !== "number" ? "0" : unit(theme.borderRadius[radius]);
};
export default getBorderRadius;